<template>
  <v-app>
    <router-view />
  </v-app>
</template>

<script>
export default {
  name: "App"
};
</script>
<style>
html {
  overflow-x: auto;
}
</style>
